export default [
  {
    path: '/faceTeaching',
    name: 'faceTeaching',
    component: () => import('@/views/faceToTeaching/faceTeachingList.vue'),
    meta: { title: 'app_offline_teaching', customWechatShare: true, isKeepAlive: true }
  },
  {
    path: '/faceDetail',
    name: 'faceDetail',
    component: () => import('@/views/faceToTeaching/faceTeachingDetail.vue'),
    meta: { title: 'app_details', customWechatShare: true, isKeepAlive: true }
  },
  {
    path: '/signDetail',
    name: 'signDetail',
    component: () => import('@/views/faceToTeaching/signDetail.vue'),
    meta: { title: 'training_confirmation', customWechatShare: true }
  },
  {
    path: '/faceTeachingImportDetail',
    name: 'faceTeachingImportDetail',
    component: () => import('@/views/faceToTeaching/faceTeachingImportDetail.vue'),
    meta: { title: 'app_details', customWechatShare: true, isKeepAlive: true }
  }
]
